module.exports = __webpack_public_path__ + "img/华特公众号二维码.53f2a7a1.jpg";